import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "icon", "hideIcon", "importance", "severity", "css", "style", "className", "as", "href", "target"];
import React from "react";
import StatusBadgeIcon from "./components/StatusBadgeIcon";
import { getIcon } from "./logic";
import { BaseStatusBadgeLink } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StatusBadgeLink = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
    icon = _ref.icon,
    _ref$hideIcon = _ref.hideIcon,
    hideIcon = _ref$hideIcon === void 0 ? false : _ref$hideIcon,
    _ref$importance = _ref.importance,
    importance = _ref$importance === void 0 ? "normal" : _ref$importance,
    _ref$severity = _ref.severity,
    severity = _ref$severity === void 0 ? "neutral" : _ref$severity,
    css = _ref.css,
    style = _ref.style,
    className = _ref.className,
    as = _ref.as,
    href = _ref.href,
    target = _ref.target,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(BaseStatusBadgeLink, _extends({
    interactive: true,
    target: target,
    href: href,
    ref: forwardedRef,
    importance: importance,
    severity: severity
  }, restProps, {
    children: [!hideIcon && /*#__PURE__*/_jsx(StatusBadgeIcon, {
      children: icon || getIcon(severity)
    }), label]
  }));
});
StatusBadgeLink.displayName = "StatusBadgeLink";
export default StatusBadgeLink;